// RiveModel.js


// App.js
import React from 'react';
// App.css removed to consolidate styles into Tailwind/index.css

//import RiveModel from "./components/RiveModel";
import RiveComponent from './components/RiveComponent';
import "./App.scss";
import { Routes, Route, useLocation } from "react-router-dom";
import { Suspense } from 'react';
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";

import Portfolio from "./containers/portfolio";
import Contact from "./containers/contact";
import Navbar from "./components/navBar";
import particles from "./utils.js/particles";

const Home = React.lazy(() => import("./containers/home"));
const About = React.lazy(() => import("./containers/about"));
const Resume = React.lazy(() => import("./containers/resume"));
const Skills = React.lazy(() => import("./containers/skills"));

function App() {
  const location = useLocation();
  console.log(location);

  const handleInit = async (main) => {
    await loadFull(main);
  };

  const renderParticleJsInHomePage = location.pathname === "/";

  return (
    <div className="App">
      {/* particles js */}

      {renderParticleJsInHomePage && (
        <Particles id="particles" options={particles} init={handleInit} />
      )}

      {/* navbar */}
      <Navbar />

      {/* main page content */}
      <div className="App__main-page-content">
      <Suspense fallback={<div className="p-8 text-center">Loading...</div>}>
      <Routes>
        <Route index path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="/skills" element={<Skills />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      </Suspense>
      </div>

    </div>
   
   
   // <div className="flex flex-col items-center justify-center min-h-screen">
    //   <h1 className="text-2xl font-bold mb-4">Hi , I am Shubham's AI avatar - any questions ? </h1>
    //   <RiveComponent />
    // </div>
  );
}

export default App;
